/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Specify levels of the logs.
 * @public
 */
export const LogLevel = {
    verbose: 10, // To log any verbose event for example when you are debugging something.
    default: 20, // Default log level
    error: 30, // To log errors.
};
//# sourceMappingURL=logger.js.map